import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Field } from '../../../../base/interfaces/field';

@Component({
  selector: '[app-easysuite-page-text]',
  templateUrl: './easysuite-page-text.component.html',
  styleUrls: ['./easysuite-page-text.component.css']
})
export class EasysuitePageTextComponent implements OnInit {
  @Input() field: Field;

  constructor() { }

  ngOnInit(): void {
  }
}
